import moment from "moment";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { BsFilePdf, BsThreeDots } from "react-icons/bs";
import { renderAttachments, renderMessage, renderReply } from "./commonMessage";
const RightSideMessage = ({
  data,
  ind,
  highlightMsg,
  setIsReplay,
  setSelectReplyData,
  handleViewProfile = () => { },
  scrollToMessage = () => { },
}) => {
  //----------handle-reply-message-------------
  const handleReply = (data) => {
    setSelectReplyData(data);
    setIsReplay(true);
  };

  // const renderReply = () => {
  //   const replyData = data?.replyOf;
  //   if (!replyData) return null;

  //   return (
  //     <div
  //       className="reply-message"
  //       onClick={() => scrollToMessage(replyData._id)}
  //       style={{
  //         padding: "8px",
  //         borderLeft: "3px solid #ccc",
  //         marginBottom: "5px",
  //         cursor: "pointer",
  //       }}
  //     >
  //       <div style={{ fontWeight: "bold", fontSize: "0.9em" }}>
  //         {replyData?._sender?.fullName}
  //       </div>
  //       {replyData?.message && (
  //         <div className="reply-text" style={{ fontSize: "0.85em" }}>
  //           {replyData.message}
  //         </div>
  //       )}
  //       {replyData?.attachments?.length > 0 && (
  //         <div className="reply-image-preview">
  //           {renderReplyAttachment(replyData.attachments[0].url)}
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  // // --------here-check-if-link-or-normal-message-------------
  // const renderMessage = () => isLink(data.message);

  // // --------here-show-image-and-pdf-------------
  // const renderAttachments = () => {
  //   if (data.attachments?.length > 0) {
  //     return data.attachments.map((file) => {
  //       const fileType = file.type?.toUpperCase();
  //       if (fileType === "IMAGE") {
  //         return (
  //           <img
  //             key={file._id}
  //             src={file.url}
  //             alt="attachment"
  //             onClick={() => handleViewProfile(file.url)}
  //             style={{
  //               maxWidth: "200px",
  //               maxHeight: "200px",
  //               marginTop: "5px",
  //               borderRadius: "8px",
  //               cursor: "pointer",
  //             }}
  //           />
  //         );
  //       } else if (fileType === "DOCUMENTS") {
  //         return (
  //           <div key={file._id} style={{ marginTop: "8px", cursor: "pointer" }} onClick={() => handleViewProfile(file.url)}>
  //             <BsFilePdf size={50} color="red" title="Open PDF" />
  //           </div>
  //         );
  //       }

  //       // You can add a fallback for other file types if needed
  //       return (
  //         <div key={file._id} style={{ fontSize: "0.9em", color: "#999" }}>
  //           Unsupported file type
  //         </div>
  //       );
  //     });
  //   }
  //   return null;
  // };


  return (
    <div className={`unique_message_box msg-item`} key={ind}>
      <div
        className={`message-sender reply_on_msg ${highlightMsg ? "highlight-message" : ""}`}
      >
        <div className="msg-header d-flex justify-content-between">
          <span className="msg-time">{moment(data?.createdAt).fromNow()}</span>
          <div className="three-dotss">
            <Dropdown>
              <Dropdown.Toggle variant="link" id="dropdown-basic">
                <BsThreeDots />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleReply(data)}>
                  Reply
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {renderReply(data, scrollToMessage)}

        <div className="msg-body">
          {renderMessage(data)}
          {renderAttachments(data, handleViewProfile)}
        </div>
      </div>
    </div>
  );
};

export default RightSideMessage;